import { EntityConfig } from "../..";

export const EncomendasTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true,
    },
    {
      id: 'designacao',
      label: 'Designação',
      type: 'text',
      filterable: true
    },
    {
        id: 'amount',
        label: 'Quantidade',
        type: 'number'
      },
      {
        id: 'price',
        label: 'Preço',
        type: 'number'
      }
  ];
  